import React from "react";

function Treatments() {
    return(
        <div>
            <h1>Behandlingar</h1>
        </div>
    )
}

export default Treatments